import { Record } from "@/classes/Record/Record";
import { autoId } from "@/lib/autoId";
import { firestore } from "@/firebase";
import { Time } from "@/lib/Time";
export class RecordReader {
  _userId;

  constructor({ userId } = {}, $store) {
    this.$store = $store;
    if (userId == undefined) {
      throw Error("userId is required in ProjectReader");
    }
    this._userId = userId;
  }

  // This is async compared to other real time readers.
  async getRecordsByProjectId(projectId, count = 8) {
    let querySnapshot = await firestore
      .collection(`users/${this._userId}/projects/${projectId}/records/`)
      .orderBy("creationTimestamp", "desc")
      .limit(count)
      .get();
    let result = querySnapshot.docs.map(doc => {
      let r = new Record(doc.ref.path);
      r.updateData(Time.date.firebaseTimestampsToDate(doc.data()));
      r.onRemove(() => {
        this.$store.dispatch("removeRecord", r);
        let i = result.findIndex(element => {
          return element === r;
        });
        result.splice(i, 1);
      });
      return r;
    });
    return result;
  }

  create(projectId) {
    let r = new Record(
      `users/${this._userId}/projects/${projectId}/records/${autoId()}`
    );
    r.updateData({
      userId: this._userId,
      projectId
    });
    r.onSave(() => {
      this.$store.dispatch("addRecord", r);
    });
    return r;
  }
}
